import { DEFAULT_LOCALE } from "@utils/default";

const localemappingWithFallback: Record<string, string> = {
  ar: "ar",
  "ar-ae": "ar",
  "ar-sa": "ar",
  "ar-eg": "ar",
  "ar-dz": "ar",
  "ar-jo": "ar",
  "ar-qa": "ar",
  "ar-iq": "ar",
  "ar-ma": "ar",
  "ar-kw": "ar",
  "ar-tn": "ar",
  "ar-cn": "ar",
  "ar-gb": "ar",
  ru: "ru",
  "ar-ru": "ar",
  "ru-ae": "ru",
  "ru-cn": "ru",
  "ru-gb": "ru",
  "ru-by": "ru",
  "ru-de": "ru",
  "ru-tr": "ru",
  "ru-ru": "ru",
  en: "en",
  "en-ae": "en",
  "en-us": "en",
  "en-cn": "en",
  "en-gb": "en",
  "en-ca": "en",
  "en-au": "en",
  "en-sg": "en",
  "en-tr": "en",
  "en-iq": "en",
  "en-it": "en",
  "en-in": "en",
  "en-de": "en",
  "en-fr": "en",
  "en-ru": "en",
  zh: "zh",
  "zh-cn": "zh",
  "zh-ae": "zh",
  "zh-tw": "zh",
  "zh-sg": "zh",
  "zh-my": "zh",
  "zh-hk": "zh",
  "zh-us": "zh",
  "zh-ca": "zh",
  "zh-au": "zh",
  "zh-gb": "zh",
  "zh-th": "zh",
  de: "de",
  "de-de": "de",
  "de-ae": "de",
  "de-ch": "de",
  "de-li": "de",
  "de-lu": "de",
  "de-at": "de",
  "de-mc": "de",
  "de-it": "de",
  "de-gr": "de",
  "de-pt": "de",
  "de-rs": "de",
  "de-hr": "de",
  "de-is": "de",
  fr: "fr",
  "fr-ae": "fr",
  "fr-es": "fr",
  "fr-lb": "fr",
  "fr-is": "fr",
  "fr-pt": "fr",
  "fr-lr": "fr",
  "fr-qa": "fr",
  "fr-ca": "fr",
  "fr-lu": "fr",
  "fr-mc": "fr",
  "fr-ma": "fr",
  "fr-be": "fr",
  "fr-sn": "fr",
  "fr-cg": "fr",
  "fr-ch": "fr",
  "fr-fr": "fr",
  tr: "tr",
  "tr-tr": "tr",
  "tr-cy": "tr",
};

export const mapLocaleCodeWithDefault = (locale: string): string => {
  return localemappingWithFallback[locale] || DEFAULT_LOCALE; // fallback to 'en' if not found
};
